module.exports = __webpack_public_path__ + "static/img/苹果Apple Watch Series 10.3fe9e62b.png";